<template>
  <md-table-row md-align="start" class="align-left" id="myid">
    <md-table-cell>{{ customer.customId }}</md-table-cell>
    <md-table-cell>{{ customer.name }}</md-table-cell>
    <md-table-cell id="num-of-users" md-numeric>{{ numberOfUsers }}</md-table-cell>
    <md-table-cell id="product-list">
      <span v-if="loading">{{ productListAssigned }}
        <md-spinner :md-size="13" md-indeterminate class=""></md-spinner>
      </span>
      <span v-else-if="productListAssigned === noproductlist" class="not-usable">{{ productListAssigned }}</span>
      <span v-else>
        <a class="custom-link" href='#' @click="productListClicked()">{{ productListAssigned }}</a>
      </span>
    </md-table-cell>
    <md-table-cell>{{ customer.note }}</md-table-cell>

    <md-dialog md-open-from="#delete-customer" md-close-to="#delete-customer" ref="dialog">
      <md-dialog-title><translate>Are you sure you want to delete depot:</translate></md-dialog-title>
      <md-dialog-content>
        <md-layout md-align="center"><span class="md-headline">{{ customer.name }}</span></md-layout>
        <br />
        <md-layout v-if="usersAtCustomer.length > 0" md-align="center" class="md-body-1">
          <div>
          <translate>With assigned users:</translate>
          <ul align="left">
            <li class="users-at-customer" v-for="(user, index) in usersAtCustomer" :key="index">{{ (user !== undefined ? user.firstname : "") + " " + (user !== undefined ? user.lastname : "") }}</li>
          </ul>
          </div>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button id="close-dialog" class="md-default" @click.native="closeDialog('dialog')"><translate>Cancel</translate></md-button>
        <md-button id="confirm-dialog" class="md-raised md-accent" @click.native="confirmDialog('dialog')"><translate>Delete</translate></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-table-cell class="cell-icon-container">
      <md-button @click.native="clickEdit(customer)" class="md-icon-button">
        <md-icon class="cell-icon">edit</md-icon>
      </md-button>
    </md-table-cell>
    <md-table-cell class="cell-icon-container">
      <md-button id="delete-customer" @click.native="openDialog('dialog')" class="md-icon-button">
        <md-icon class="cell-icon">delete</md-icon>
      </md-button>
    </md-table-cell>
  </md-table-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'customer-row',
  data () {
    return {
      loading: false
    }
  },
  props: ['customer'],
  computed: {
    noproductlist () {
      return this.$gettext('No product list')
    },
    numberOfUsers () {
      return (this.customer.users) ? this.customer.users.length : 0
    },
    productListAssigned () {
      if (this.allProductLists === undefined) { // this prevents error message before all the products are loaded
        this.loading = true // eslint-disable-line
        return this.$gettext('Loading') + ' '
      } else {
        this.loading = false // eslint-disable-line
      }

      if (this.customer.productList === '' || this.allProductLists.length === 0) {
        return this.noproductlist
      }
      let pList = this.allProductLists.find((prodList) => {
        return prodList._id === this.customer.productList
      })
      console.log('pList.name', pList.name)
      return pList.name || ''
    },
    usersAtCustomer () { // list the all users assigned to this customer
      if (this.customer.users === undefined || this.customer.users.length === 0) {
        return []
      }
      return this.customer.users.map((user) => { // map the array of _ids to array of users
        return this.allUsers.find((usr) => {
          return user === usr._id
        })
      })
    },
    ...mapGetters([
      'allUsers',
      'allProductLists'
    ])
  },
  methods: {
    ...mapMutations([
      'customerEdit',
      'customerToDelete',
      'customerCancelDelete'
    ]),
    productListClicked () {
      this.$emit('productListClicked', this.productListAssigned)
    },
    openDialog (ref) {
      this.$refs[ref].open()
      this.customerToDelete(this.customer)
    },
    closeDialog (ref) {
      this.$refs[ref].close()
      this.customerCancelDelete()
    },
    confirmDialog (ref) {
      this.$refs[ref].close()
      this.$store.dispatch('deleteCustomers')
    },
    clickEdit (customer) {
      this.$router.push({ name: 'tab-0-edit', params: { id: customer._id } })
      this.customerEdit(customer._id)
    }
  }
}
</script>

<style>
/*
Defined in users/Row.vue
.delete-icon
.edit-icon
.align-left
*/
a.custom-link {
  color: rgba(0,0,0,.87) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/customers/Row.vue